import { render, staticRenderFns } from "./InspectionConfig.vue?vue&type=template&id=3877dbb7"
import script from "./InspectionConfig.vue?vue&type=script&lang=js"
export * from "./InspectionConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports